import type { TFunction } from 'i18next'

/** "seconds ago" / "5 minutes ago" / "3 hours ago" / "Aug 2, 2025" — OnlyFans' post date style. */
export function relativeTime(iso: string, t: TFunction, now = Date.now()): string {
  const at = new Date(iso).getTime()
  if (!Number.isFinite(at)) return ''
  const sec = Math.round((now - at) / 1000)
  if (sec < 60) return t('time.seconds')
  if (sec < 3600) return t('time.minutes', { count: Math.floor(sec / 60) })
  if (sec < 86400) return t('time.hours', { count: Math.floor(sec / 3600) })
  const d = new Date(at)
  const sameYear = d.getFullYear() === new Date(now).getFullYear()
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', ...(sameYear ? {} : { year: 'numeric' }) })
}
